import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class KeyContents {
  private _contents = new Subject<any>();
  public contents = this._contents.asObservable();
  content_dict: any = {};
  public setContents (response: any) {
    this.content_dict = response;
    this.getContents()
  }

  public getContents () {
    this._contents.next(this.content_dict);
  }
}


// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/services/keycontents.service.ts